import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import {
  DataTableCell,
  TableBody as TableBodyPDF,
  TableCell as TableCellPDF,
  TableHeader as TableHeaderPDF,
} from "@david.kucsai/react-pdf-table";
import { TablePdf } from "../TablePdf/TablePdf";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewPaymentMethodsInhouse(props) {
  let totalCount = 0;
  let totalAmount = 0;
  let totalCountNoTurnover = 0;
  let totalAmountNoTurnover = 0;
  let payments = Object.keys(props.payments)
    .filter((paymentMethod) => props.payments[paymentMethod].isTurnover)
    .map((paymentMethod) => {
      totalCount += props.payments[paymentMethod].count;
      totalAmount += props.payments[paymentMethod].amount;
      return (
        <TableRow key={paymentMethod}>
          <TableCell>{paymentMethod}</TableCell>
          <TableCell align={"right"}>{props.payments[paymentMethod].count}</TableCell>
          <TableCell align={"right"}>
            {GetCurrency()} {(props.payments[paymentMethod].amount / 100.0).toFixed(2)}
          </TableCell>
        </TableRow>
      );
    });
  let paymentsNoTurnover = Object.keys(props.payments)
    .filter((paymentMethod) => !props.payments[paymentMethod].isTurnover)
    .map((paymentMethod) => {
      totalCountNoTurnover += props.payments[paymentMethod].count;
      totalAmountNoTurnover += props.payments[paymentMethod].amount;
      return (
        <TableRow key={paymentMethod}>
          <TableCell>{paymentMethod}</TableCell>
          <TableCell align={"right"}>{props.payments[paymentMethod].count}</TableCell>
          <TableCell align={"right"}>
            {GetCurrency()} {(props.payments[paymentMethod].amount / 100.0).toFixed(2)}
          </TableCell>
        </TableRow>
      );
    });

  const getPdfView = () => {
    return (
      <>
        <TablePdf
          data={Object.keys(props.payments)
            .filter((paymentMethod) => props.payments[paymentMethod].isTurnover)
            .map((paymentMethod) => {
              return { paymentMethod: paymentMethod };
            })}
        >
          <TableHeaderPDF>
            <TableCellPDF weighting={0.3}>Betalingen</TableCellPDF>
            <TableCellPDF weighting={0.3} align={"right"}>
              Aantal
            </TableCellPDF>
            <TableCellPDF weighting={0.3} align={"right"}>
              Bedrag
            </TableCellPDF>
          </TableHeaderPDF>
          <TableBodyPDF>
            <DataTableCell weighting={0.3} getContent={(r) => r.paymentMethod} />
            <DataTableCell weighting={0.3} align={"right"} getContent={(r) => props.payments[r.paymentMethod].count} />
            <DataTableCell
              weighting={0.3}
              align={"right"}
              getContent={(r) => GetCurrency() + (props.payments[r.paymentMethod].amount / 100.0).toFixed(2)}
            />
          </TableBodyPDF>
          <TableHeaderPDF>
            <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
            <TableCellPDF weighting={0.3} align={"right"}>
              {totalCount}
            </TableCellPDF>
            <TableCellPDF weighting={0.3} align={"right"}>
              {GetCurrency() + (totalAmount / 100.0).toFixed(2)}
            </TableCellPDF>
          </TableHeaderPDF>
        </TablePdf>
        <TablePdf
          data={Object.keys(props.payments)
            .filter((paymentMethod) => !props.payments[paymentMethod].isTurnover)
            .map((paymentMethod) => {
              return { paymentMethod: paymentMethod };
            })}
        >
          <TableHeaderPDF>
            <TableCellPDF weighting={0.3}>Andere boekingen</TableCellPDF>
            <TableCellPDF weighting={0.3} align={"right"}>
              Aantal
            </TableCellPDF>
            <TableCellPDF weighting={0.3} align={"right"}>
              Bedrag
            </TableCellPDF>
          </TableHeaderPDF>
          <TableBodyPDF>
            <DataTableCell weighting={0.3} getContent={(r) => r.paymentMethod} />
            <DataTableCell weighting={0.3} align={"right"} getContent={(r) => props.payments[r.paymentMethod].count} />
            <DataTableCell
              weighting={0.3}
              align={"right"}
              getContent={(r) => GetCurrency() + (props.payments[r.paymentMethod].amount / 100.0).toFixed(2)}
            />
          </TableBodyPDF>
          <TableHeaderPDF>
            <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
            <TableCellPDF weighting={0.3} align={"right"}>
              {totalCountNoTurnover}
            </TableCellPDF>
            <TableCellPDF weighting={0.3} align={"right"}>
              {GetCurrency() + (totalAmountNoTurnover / 100.0).toFixed(2)}
            </TableCellPDF>
          </TableHeaderPDF>
        </TablePdf>
      </>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Betalingen omzet</TableCell>
            <TableCell align={"right"}>Aantal</TableCell>
            <TableCell align={"right"}>Bedrag</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{payments}</TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align={"right"}>{totalCount}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(totalAmount / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Andere boekingen</TableCell>
            <TableCell align={"right"}>Aantal</TableCell>
            <TableCell align={"right"}>Bedrag</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{paymentsNoTurnover}</TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align={"right"}>{totalCountNoTurnover}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(totalAmountNoTurnover / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
